import { render, staticRenderFns } from "./installation.vue?vue&type=template&id=95aa0222"
import script from "./installation.vue?vue&type=script&lang=js"
export * from "./installation.vue?vue&type=script&lang=js"
import style0 from "./installation.vue?vue&type=style&index=0&id=95aa0222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports